/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MapAddressDto } from './mapAddressDto';

/**
 * Action
 */
export interface MapTerrainAction { 
    address: MapAddressDto;
    /**
     * Terrain
     */
    terrain: MapTerrainAction.TerrainEnum;
}
export namespace MapTerrainAction {
    export type TerrainEnum = 'Mountain' | 'Forest' | 'Grassland' | 'Desert' | 'Water';
    export const TerrainEnum = {
        Mountain: 'Mountain' as TerrainEnum,
        Forest: 'Forest' as TerrainEnum,
        Grassland: 'Grassland' as TerrainEnum,
        Desert: 'Desert' as TerrainEnum,
        Water: 'Water' as TerrainEnum
    };
}